import { useApi, type GetIssueResponseDto } from '@issuemanager/api-client';
import { type ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { SaveAttachmentDto } from '@issuemanager/routes';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type UseApproveActionParams = {
  issueCode: string;
  onSuccess: () => void;
};
type UseApproveActionMutationParams = {
  id: string;
  attachments?: SaveAttachmentDto[];
};

export function useApproveAction({
  issueCode,
  onSuccess,
}: UseApproveActionParams) {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<
    GetIssueResponseDto,
    ExtendedAxiosError,
    UseApproveActionMutationParams
  >({
    mutationKey: ['actions'],
    mutationFn: ({ id, attachments }) =>
      api.issuesApi
        .approveAction(issueCode, id, { attachments })
        .then((r) => r.data),
    onSuccess: async (issue) => {
      queryClient.setQueriesData<GetIssueResponseDto>(
        { queryKey: ['issues', issueCode], exact: true },
        () => ({ ...issue }),
      );
      await queryClient.invalidateQueries({
        queryKey: ['issues', issueCode, 'timeline'],
      });
      onSuccess();
    },
  });
}
